import { useEffect, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import apiClient from "../api/apiClient";
import "../css/OpenGame.css";
import "../css/mainhome.css";
import InfoModal from "../components/infoModal";
import AppHeader from "../components/AppHeader";

export default function OpenGame() {
  const [gameTypes, setGameTypes] = useState([]);
  const [isBidTimePassed, setIsBidTimePassed] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");

  const navigate = useNavigate();
  const { marketId } = useParams();
  const location = useLocation();
  const walletBalance = localStorage.getItem("walletBalance");
  const gameTitle = location.state?.gameName || `Market ${marketId}`;
  const openBidTime = location.state?.openBidTime;

  useEffect(() => {
    const fetchGameTypes = async () => {
      try {
        const mobileNo = localStorage.getItem("mobileNo");

        const res = await apiClient.get("/game-bid-type", {
          params: { mobileNo },
        });

        if (res.data?.status && Array.isArray(res.data.info)) {
          setGameTypes(res.data.info);
        } else {
          console.error("Invalid API response:", res.data);
        }
      } catch (err) {
        console.error("API error:", err);
      }
    };

    fetchGameTypes();

    if (openBidTime) {
      const now = new Date();
      const bidTime = new Date(now);
      const m = openBidTime.match(/(\d+):(\d+)\s*(AM|PM)/i);
      if (m) {
        let h = parseInt(m[1], 10);
        const min = parseInt(m[2], 10);
        const ap = m[3].toUpperCase();
        if (ap === "PM" && h < 12) h += 12;
        if (ap === "AM" && h === 12) h = 0;
        bidTime.setHours(h, min, 0, 0);
        if (now > bidTime) setIsBidTimePassed(true);
      }
    }
  }, [openBidTime]);

  const handleCardClick = (game) => {
    if (isBidTimePassed) {
      if (game.sessionSelection === true) {
        navigate(`/bid/market/${marketId}/${game.type}`, {
          state: {
            marketName: gameTitle,
            openBidDisabled: true,
            sessionSelection: game.sessionSelection,
          },
        });
      } else {
        setModalMessage(`The market for ${game.name} is currently closed.`);
        setIsModalOpen(true);
      }
      return;
    }

    navigate(`/bid/market/${marketId}/${game.type}`, {
      state: {
        marketName: gameTitle,
        openBidDisabled: false,
        sessionSelection: game.sessionSelection,
      },
    });
  };

  return (
    <div className="mainhome-screen-wrapper">
      <AppHeader
        title={gameTitle}
        walletBalance={walletBalance}
        onBack={() => navigate(-1)}
        onWalletClick={() => navigate("/passbook")}
      />

      <div
        className="open-game-container"
        style={{
          flex: 1,
          overflowY: "auto",
          paddingBottom: "100px",
          WebkitOverflowScrolling: "touch",
          scrollbarWidth: "none",
        }}
      >
        <div className="game-grid">
          {gameTypes.map((type) => (
            <div
              key={type.id}
              className="game-carrd"
              onClick={() => handleCardClick(type)}
              role="button"
            >
              <div className="icon-wrapper">
                <img src={type.image} alt={type.name} />
              </div>
              <p>{type.name}</p>
            </div>
          ))}
        </div>
      </div>

      <InfoModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title="Market Closed"
        message={modalMessage}
      />
    </div>
  );
}